module.exports = __webpack_public_path__ + "static/media/gerbauer_fernandez_pollock_kennedy_dimaggio.8a2f9efe.gif";